// services
import db from '@/services/db'
import storage from '@/services/storage'

export default {
  getFileUrls ({ commit, state }, cb) {
    db.files.read(async (files) => {
      const filesReady = {}

      for (let key in files) {
        filesReady[key] = {
          key,
          url: null,
          name: files[key]
        }
      }

      commit('setFiles', filesReady)

      cb()

      for (let key in filesReady) {
        const file = filesReady[key]

        storage.getFileUrl(state.currentDash, `${key}_${file.name}`, (err, url) => {
          if (!err) state.files[key].url = url
          else console.log(err)
        })
      }
    })
  }
}